import React, { Component } from 'react'
import { Input, Button, Table, Pagination, message } from 'antd'
import moment from 'moment';
import { getInfoList } from '../api'
// const { Option } = Select


class InfoList extends Component {
    constructor () {
        super()
        this.state = {
            searchInfo: {
                productId: '',
                title: '',
                type: 0
            },
            tableInfo: {
                columns: [
                    {
                        title: '文章标题',
                        dataIndex: 'title',
                        render: (title, row) => <a href={`#infoDisclosure/${+row.id}`} target="_blank" rel="noopener noreferrer">{title}</a>,
                    },
                    {
                        title: '日期',
                        dataIndex: 'date',
                        render: val => <span>{moment(val).format('YYYY-MM-DD')}</span>,
                    }
                ],
                data: []
            },
            pageInfo: {
                pageNo: 1,
                pageSize: 10,
                total: 0
            }
        }
    }

    // 页码改变
    handleCurrentChange = (page) => {
        this.setState({
            pageInfo: {...this.state.pageInfo, pageNo: page}
        }, () => {
            this.getInfoList()
        })
    }

    componentDidMount () {
       this.getInfoList()
    }

    // 获取信息列表
    getInfoList = () => {
        const { pageInfo, searchInfo } = this.state
        const params = {...pageInfo, ...searchInfo}
        getInfoList(params).then(res => {
            if (res.data) {
                const tableData = res.data.map(({id, title, publishtime, count}) => {
                    return {
                        id,
                        title,
                        date: publishtime,
                        key: id,
                        total: count,
                    }
                })
                this.setState({
                    tableInfo: { ...this.state.tableInfo, data: tableData },
                    pageInfo: {...this.state.pageInfo, total: tableData.length > 0 ? Number(tableData[0].total): 0 }
                })
            }
        }).catch(err => {
            message.error(err.msg)
        })
    }
    
    render () {
        const { searchInfo, pageInfo } = this.state
        const { columns, data } = this.state.tableInfo
        return (
            <div>
                <div className="page-content-info">
                    <div className="search-items">
                        {/* <div className="search-item">
                            <span>产品代码：</span><Input width="230" height="36" onChange={ e => searchInfo.productId = e.target.value } />
                        </div> */}
                        <div className="search-item">
                            <span>文章标题：</span><Input className="searchInput"  onChange={ e => searchInfo.title = e.target.value }/>
                            <Button onClick={() => this.getInfoList()}>查询</Button>
                        </div>
                        {/* <div className="search-item">
                            <span>类型：</span>
                            <Select defaultValue="0" style={{width: '230px', height: '36px'}} onChange={ value => searchInfo.type = value }>
                                <Option value="0">全部</Option>
                            </Select>
                        </div> */}
                        {/* <Button onClick={() => this.getInfoList()}>查询</Button> */}
                    </div> 
                    <div className="search-table">
                        <Table columns={ columns } dataSource={ data } pagination={false}></Table>
                        {
                            pageInfo.total > 0 && <Pagination current={pageInfo.pageNo} pageSize={pageInfo.pageSize} total={pageInfo.total} showTotal={(total, range) => `${range[0]}-${range[1]} 共 ${total} 条`} onChange={(page) => this.handleCurrentChange(page)}/>
                        }
                    </div>   
                </div>
            </div>
        )
    }
}

export default InfoList